import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserCashPlan = React.lazy(() =>
    import('../UserCashPlan')
);
const userCashPlanRoutesRegistry = [
    {
        path: PAGE_URL.USER_CASH_PLAN_PAGE,
        element: <UserCashPlan />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userCashPlanRoutesRegistry;
